import { jsx as p, jsxs as ee } from "react/jsx-runtime";
import { useReducer as te, useState as S, useEffect as T, useMemo as h } from "react";
import { DesktopInteractionArea as oe } from "./components/elements/desktop-interaction-area/desktop-interaction-area.js";
import { MapView as ie } from "./components/elements/map-view/map-view.js";
import { MobileDrawer as se } from "./components/elements/mobile-drawer/mobile-drawer.js";
import ne from "./find-station.module.less.js";
import { FindStationReducer as ae, InitialFindStationState as re } from "./state/find-station-reducer.js";
import { FilterDialog as le } from "./components/elements/filter-dialog/filter-dialog.js";
import ce from "./components/elements/station-dialog/station-dialog.js";
import { APIProvider as pe, useMap as de } from "@vis.gl/react-google-maps";
import { getFindStationFilters as me, getFindStationQuickFilters as ue } from "./data/filters.js";
import { useTranslation as Se } from "react-i18next";
import { filterStations as ge, getLabelForFilterGroup as Fe } from "./helpers/filter-functions.js";
import { useStationsQuery as Te } from "./react-query-queries/use-stations-query.js";
import { isMobileDevice as he } from "../../helpers/device-helper.js";
import { isArrayWithItems as W } from "../../helpers/array-helper.js";
import "dayjs";
import { convertStationsToGeoJson as fe } from "./helpers/marker-helper.js";
import { extendStationsWithSearchIndex as Ce, filterStationsBySearchTerm as Ee } from "./helpers/station-search-helper.js";
import { useGeolocation as ye } from "../../hooks/useGeolocation.js";
import "../../contexts/global-context.js";
import "motion/react";
import "../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "haversine-distance";
import "usehooks-ts";
import "react-countup";
import "embla-carousel-react";
import "react-loading-skeleton";
/* empty css                                                          */
import "@tanstack/react-query";
import "lodash-es";
import "../../components/form-elements/input/input.js";
import "react-hook-form";
import "../../components/form-elements/file-upload/file-upload.js";
import "../../components/form-elements/select/select.js";
import "@radix-ui/react-slider";
import "../../components/blocks/customer-service/company-forms.js";
import "../../labels/i18n.js";
import "body-scroll-lock";
import "@radix-ui/react-visually-hidden";
import f from "../../events/event-aggregator.js";
import { EVENT as C } from "../../events/event.js";
import { getTrackingObjectForStation as O } from "./helpers/tracking-helper.js";
import { extendStationsWithDistanceAndSortByUserPosition as _e } from "./helpers/geo-helper.js";
/* empty css                       */
const V = 210, Me = (l, d) => {
  const t = [];
  for (const o of l) {
    const n = t.find((c) => c.name === o.group);
    n ? n.filters.push(o) : t.push({
      title: Fe(o.group, d),
      name: o.group,
      filters: [{ ...o }]
    });
  }
  return t;
}, Oe = (l, d) => {
  if (!l)
    return {
      distanceInMeters: -1,
      stations: []
    };
  const t = _e(l, d);
  for (let o = 5e3; o < 5e5; o += 5e3) {
    const n = t.filter((c) => c.distanceInMeters <= o);
    if (W(n))
      return {
        stations: n,
        distanceInMeters: o
      };
  }
  return {
    distanceInMeters: -1,
    stations: []
  };
}, Le = ({
  trailerRentalPageUrl: l,
  trailerRentalStationUrlResolveFunction: d
}) => {
  const [t, o] = te(ae, re), [n, c] = S(), [j, L] = S(!1), [u, k] = S(""), [Q, K] = S(!1), [v, A] = S(!1), { geolocation: s, isLoadingGeolocation: D, startWatchPosition: q, stopWatchPosition: H } = ye(), a = de("station-map"), { data: m, isFetched: J } = Te();
  T(() => (q(), () => {
    H();
  }), []), T(() => {
    if (!v && s && s.lat && s.lng && a && m) {
      const { stations: e, distanceInMeters: r } = Oe(s, m), w = he();
      if (e.length >= 3 || r <= 1e4)
        a.setCenter({ lat: s.lat, lng: s.lng }), a.setZoom(11), w || a.panBy(V * -1, 0), A(!0);
      else {
        const B = e.map((F) => ({
          lat: F.latitude,
          lng: F.longitude
        }));
        B.push(s);
        const M = new google.maps.LatLngBounds();
        for (const F of B)
          M.extend(F);
        a.fitBounds(M, 140), a.setCenter(M.getCenter()), w || a.panBy(V * -1, 0), A(!0);
      }
    }
  }, [a, v, s, m]);
  const E = J && W(m), Z = h(
    () => Ce(m),
    [E, m]
  ), { t: y } = Se(), N = me(y), z = h(() => Me(N, y), [N]), i = t.selectedStationCode && E ? m.find((e) => e.stationCode === t.selectedStationCode) : null;
  T(() => {
    i && f.publish(C.TRACK_EVENT, {
      event: "view_station",
      station: i.stationName,
      station_type: i.stationType,
      station_concept: i.stationConcept,
      filters_applied: t.selectedFilters.size > 0 ? "yes" : "no",
      station_search_query: u
    });
  }, [i]), T(() => {
    t.isFilterModalOpen && c(t.selectedFilters);
  }, [t.isFilterModalOpen]);
  const U = (e) => {
    const r = new Map(n);
    e.type === "checkbox" && (e.checked ? r.set(e.name, {
      name: e.name,
      group: e.group,
      value: e.value
    }) : r.delete(e.name)), e.type === "slider" && r.set(e.name, {
      name: e.name,
      group: e.group,
      value: String(e.value)
    }), c(r);
  }, G = (e) => {
    e.type === "checkbox" && (e.checked ? o({
      type: "ADD_FILTER",
      payload: {
        filterName: e.name,
        filterValue: {
          name: e.name,
          group: e.group,
          value: e.value
        }
      }
    }) : o({
      type: "REMOVE_FILTER",
      payload: { filterName: e.name }
    }));
  }, b = () => {
    o({ type: "TOGGLE_FILTER_MODAL", payload: { isFilterModalOpen: !0 } });
  }, _ = (e, r) => {
    t.selectedStationCode === e ? o({ type: "DESELECT_STATION" }) : (o({ type: "SELECT_STATION", payload: { selectedStationCode: e } }), r && (a?.setCenter(r), a?.setZoom(11)));
  }, X = () => {
    t.selectedStationCode && o({ type: "DESELECT_STATION" });
  }, g = E ? ge(Z, t.selectedFilters) : [], Y = h(() => fe(g), [g]), R = h(
    () => Ee(g, u),
    [g, u]
  ), x = (e) => {
    k(e.target.value);
  }, P = () => {
    k("");
  }, $ = {
    onPreNavigateStationDirections: () => {
      if (!i)
        return;
      const e = O(i, t.selectedFilters);
      f.publish(C.TRACK_EVENT, {
        event: "station_search_success",
        ...e
      });
    },
    onPreNavigatePhoneNumber: () => {
      if (!i)
        return;
      const e = O(i, t.selectedFilters);
      f.publish(C.TRACK_EVENT, {
        event: "station_tel",
        ...e
      });
    },
    onPreNavigateTrailerRental: () => {
      if (!i)
        return;
      const e = O(i, t.selectedFilters);
      f.publish(C.TRACK_EVENT, {
        event: "start_book_trailer",
        ...e
      });
    }
  }, I = ue(y);
  return /* @__PURE__ */ ee("section", { className: ne.wrapper, children: [
    /* @__PURE__ */ p(
      ie,
      {
        onClickItem: _,
        stations: Y,
        onDragStart: () => L(!0),
        onDragEnd: () => L(!1),
        userPosition: s,
        selectedStation: i ?? void 0,
        onClickMap: X
      }
    ),
    /* @__PURE__ */ p(
      oe,
      {
        isDraggingMap: j,
        quickFilters: I,
        selectedFilters: t.selectedFilters,
        stationRows: R,
        onClickOpenAllFilters: () => b(),
        onChangeQuickFilters: (e) => G(e),
        onClickStation: _,
        onChangeSearchTermInput: x,
        onClickClearSearchTerm: P,
        searchTerm: u,
        selectedStationCode: t.selectedStationCode,
        geolocation: s,
        isLoadingGeolocation: D,
        onClickCollapse: () => K((e) => !e),
        isCollapsed: Q
      }
    ),
    /* @__PURE__ */ p(
      se,
      {
        quickFilters: I,
        selectedFilters: t.selectedFilters,
        stationRows: R,
        onClickOpenAllFilters: () => b(),
        onChangeQuickFilters: (e) => G(e),
        onClickStation: _,
        isOpen: t.isListExpanded,
        onClose: () => o({ type: "TOGGLE_LIST", payload: { isListExpanded: !1 } }),
        onOpen: () => o({ type: "TOGGLE_LIST", payload: { isListExpanded: !0 } }),
        onChangeSearchTermInput: x,
        onClickClearSearchTerm: P,
        searchTerm: u,
        geolocation: s,
        isLoadingGeolocation: D
      }
    ),
    /* @__PURE__ */ p(
      le,
      {
        filterGroups: z,
        onChange: (e) => U(e),
        selectedFilters: n || /* @__PURE__ */ new Map(),
        isOpen: t.isFilterModalOpen,
        onApprove: () => {
          o({
            type: "SET_FILTERS",
            payload: { filters: n || /* @__PURE__ */ new Map() }
          }), o({ type: "TOGGLE_FILTER_MODAL", payload: { isFilterModalOpen: !1 } }), c(void 0);
        },
        onClear: () => {
          c(/* @__PURE__ */ new Map());
        },
        onClose: () => o({ type: "TOGGLE_FILTER_MODAL", payload: { isFilterModalOpen: !1 } })
      }
    ),
    i && /* @__PURE__ */ p(
      ce,
      {
        station: i,
        isOpen: !0,
        geolocation: s,
        onClose: () => o({ type: "DESELECT_STATION" }),
        trailerRentalPageUrl: l,
        trackingFunctions: $,
        trailerRentalStationUrlResolveFunction: d
      }
    ),
    /* @__PURE__ */ p("div", { id: "find-station-portal-container" })
  ] });
}, _t = ({
  mapApiKey: l,
  trailerRentalPageUrl: d,
  trailerRentalStationUrlResolveFunction: t
}) => /* @__PURE__ */ p(pe, { apiKey: l, libraries: ["marker"], children: /* @__PURE__ */ p(
  Le,
  {
    trailerRentalPageUrl: d,
    trailerRentalStationUrlResolveFunction: t
  }
) });
export {
  V as PANEL_WIDTH_OFFSET,
  _t as default
};
